// extracted by mini-css-extract-plugin
module.exports = {"actions":"Quantity_actions__PY5Py","input":"Quantity_input__eUviu"};